import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Logo from "./template-5-logo.png";

import Template5Image1 from "./template-5-image-1.png";
import Template5Image2 from "./template-5-image-2.png";
import Template5Image3 from "./template-5-image-3.png";
import Template5Image4 from "./template-5-image-4.png";

import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class ImagesCarousel extends BaseTemplate {
  constructor() {
    super();
    this.id = "3";
    this.name = "Basic #3";
    this.url = "/ai/carousels/images-carousel";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Supergrow",
        },
        {
          label: "Profile Pic (JPG or PNG 256x256px)",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Logo,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@supergrowai",
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#F97315",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#FFFFFF",
        },
        {
          label: "Teritary Color",
          type: "color",
          key: "teritary_color",
          style_key_group: "teritary",
          value: "#000000",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Unbounded",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Inter",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Find the best web design & dev agency",
            max_words: 8,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Here are 5 tips to get you going. (Phase 1)`,
            max_words: 10,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: Template5Image1,
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Making software accessible for everyone.",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `"If you're a designer, you should just be using Stark. End of story."
- Julie Chabin`,
            max_words: 15,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: Template5Image2,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Context and navigation for your Figma designs.",
            max_words: 5,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `"Has sped up my process and flow tremendously. One of those products that you didn't realize you needed at first but now know you have to have."
- Skip Jones`,
            max_words: 25,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: Template5Image3,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "All brands. In one place.",
            max_words: 5,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `"This is a very sexy search engine helping on a very specific task that was long and painful up until now."
- Ramy Fouda`,
            max_words: 25,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: Template5Image4,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Thanks for reading",
            max_words: 3,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "bold",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Follow for more",
            max_words: 3,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "24px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "bold",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(commonSettings) {
    return commonSettings.elements[3].value;
  }

  getSecondaryColor(commonSettings) {
    return commonSettings.elements[4].value;
  }

  getTeritaryColor(commonSettings) {
    return commonSettings.elements[5].value;
  }

  getPrimaryFont(commonSettings) {
    return commonSettings.elements[6]?.value || "Unbounded";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    if (index === 0) {
      let el = {
        label: "Description",
        target_key: "description",
        value: "",
      };
      new_slide.elements.push(el);
    }

    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderIntroSlide(slide, index, currentSlide, carouselLength, commonSettings) {
    return (
      <>
        <div className="relative z-10 flex flex-col items-start flex-1 gap-4 px-8 py-10 shrink-0">
          <div
            className="text-4xl font-bold leading-none tracking-tight"
            style={{
              color: this.getSecondaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="text-base font-normal"
            style={{
              color: this.getSecondaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>

          <div className="flex items-center gap-3">
            <img
              className="object-cover w-8 h-8 rounded-full ring-2 ring-white shrink-0"
              src={commonSettings.elements[1].value.image || LogoPlaceholder}
              alt=""
            />
            <div>
              <p
                className="text-sm font-bold"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[0]?.value}
              </p>
              <p
                className="text-xs font-medium"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>
        </div>
        <div className="relative w-full h-56">
          {slide.elements[2].value && (
            <img
              className="object-cover w-full h-full"
              src={slide.elements[2].value}
              alt=""
            />
          )}
          <div className="absolute right-0 z-10 px-6 -top-6">
            <div
              className="inline-flex items-center justify-center w-12 h-12 rounded-full shadow-2xl"
              style={{
                color: this.getPrimaryColor(commonSettings),
                backgroundColor: this.getSecondaryColor(commonSettings),
              }}
            >
              <svg
                aria-hidden="true"
                className="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings
  ) {
    return (
      <>
        <div className="relative z-10 flex flex-col items-start flex-1 gap-4 px-8 py-6">
          <div className="flex items-center gap-3">
            <img
              className="object-cover w-8 h-8 rounded-full ring-1 ring-black/10 shrink-0"
              src={commonSettings.elements[1].value.image || LogoPlaceholder}
              alt=""
            />
            <div>
              <p
                className="text-sm font-bold"
                style={{
                  color: this.getTeritaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[0].value}
              </p>
              <p
                className="text-xs font-medium"
                style={{
                  color: this.getTeritaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>
          <div className="space-y-2">
            <div
              className="text-2xl leading-7 tracking-tight"
              style={{
                color: this.getTeritaryColor(commonSettings),
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>
            <div
              className="text-sm font-normal leading-6 line-clamp-4"
              style={{
                color: this.getTeritaryColor(commonSettings),
              }}
            >
              {slide.elements[1]?.style ? (
                <MultilineView
                  element={slide.elements[1]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[1]?.value} />
              )}
            </div>
          </div>
        </div>

        <div className="relative w-full h-48">
          {slide.elements[2]?.value && (
            <img
              className="object-cover w-full h-full"
              src={slide.elements[2]?.value}
              alt=""
            />
          )}

          <div className="absolute right-0 z-10 px-6 -top-6">
            <div
              className="inline-flex items-center justify-center w-12 h-12 text-lg font-bold rounded-full shadow-2xl"
              style={{
                color: this.getPrimaryColor(commonSettings),
                backgroundColor: this.getSecondaryColor(commonSettings),
              }}
            >
              {index}
            </div>
          </div>
        </div>
      </>
    );
  }

  renderOutroSlide(slide, index, currentSlide, carouselLength, commonSettings) {
    return (
      <div className="relative z-10 flex flex-col items-center justify-center flex-1 gap-12 px-8 py-10 text-center">
        <div className="flex flex-col items-center gap-3">
          <div
            className="px-4 py-2.5 text-2xl font-bold shadow-lg -rotate-3 rounded-2xl"
            style={{
              color: this.getTeritaryColor(commonSettings),
              backgroundColor: this.getSecondaryColor(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div
            className="px-4 py-2.5 text-2xl font-bold shadow-lg rounded-2xl"
            style={{
              color: this.getPrimaryColor(commonSettings),
              backgroundColor: this.getSecondaryColor(commonSettings),
            }}
          >
            {slide.elements[1]?.style ? (
              <MultilineView
                element={slide.elements[1]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[1]?.value} />
            )}
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <img
            className="object-cover w-20 h-20 rounded-full ring-1 ring-black/10"
            src={commonSettings.elements[1].value.image || LogoPlaceholder}
            alt=""
          />
          <div>
            <p
              className="text-xl font-bold"
              style={{
                color: this.getTeritaryColor(commonSettings),
              }}
            >
              {commonSettings.elements[0]?.value}
            </p>
            <p
              className="text-sm font-medium"
              style={{
                color: this.getTeritaryColor(commonSettings),
              }}
            >
              {commonSettings.elements[2]?.value}
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
      >
        <div className="absolute inset-0">
          <div
            className="w-full h-full"
            style={{
              backgroundColor: this.getPrimaryColor(commonSettings),
              opacity: index !== 0 ? 0.1 : 1,
            }}
          ></div>
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings
          )}
        {index !== 0 &&
          index !== carouselLength - 1 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings
          )}
      </div>
    );
  }
}

export default ImagesCarousel;
